import styled from 'styled-components'
import SearchTitleItem from 'Components/AutoComplete/components/SearchTitleItem'
import SearchResultItem from 'Components/AutoComplete/components/SearchResultItem'


export const _PrevSearchResultItem = styled(SearchResultItem)`
`

export const _PrevSearchResultTitle = styled(SearchTitleItem)`
  padding-left: 0;
  padding-right: 0;
  > div {
    border-top: 0;
  }
`
